import React, { useEffect, useRef } from 'react'

export const AlwaysScrollToBottom = (): React.JSX.Element => {
    // eslint-disable-next-line
    const elementRef: any = useRef()
    useEffect(() => elementRef?.current?.scrollIntoView())
    return <div ref={elementRef} />
}
